var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('l-p-form',{attrs:{"version":"v1"}}),_c('our-clients'),_c('how-do-we-do-it'),_c('what-do-you-get'),_c('reviews')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }